export default __webpack_public_path__ + "static/media/open_in_browser.25df7218.png";